module.exports = __webpack_public_path__ + "d0be49fa00171b0b12659e9dc1eeca4c.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/orks-vignette-preview-320.webp
// module id = 490
// module chunks = 0